module.exports = __webpack_public_path__ + "media/images/white-arrow-right-cb6fdf0fc36eb65af5eeae41d7ed619f.svg";